<template>
  <SubLayout
      :pageTitle="$t('projects.formalities')"
      :hasBack="false"
      ktContentContainerClass="p-0"
  >
    <template #layoutContent>
      <Card card="card p-5 bg-light h-100 " style="min-height: 75vh;" :title="$t('projects.formalities')">
        <template #cardToolbar>
          <div class="d-flex justify-content-between align-items-center w-100">
            <ButtonDropdownFilter
                :btn-title="$t('label.allProjects')"
                :options="[...projects]"
                value-field="id"
                name-field="title"
                v-model="query.project_id"
            />
            <ButtonDropdownFilter
                :btn-title="$t('projects.label.cat')"
                :options="[...categories]"
                value-field="id"
                name-field="name"
                v-model="query.project_category_id"
            />
            <Input
                :name="`${id}-bank_name`"
                type="text"
                labelClass="form-label fs-6 text-black"
                containerClass=""
                :inputClass="'form-control w-250px form-control-sm form-control-solid'"
                size="sm"
                :placeholder="$t('label.search')"
                v-model="query.search"
            />
          </div>
        </template>
        <template #cardBody>
          <Loader :isLoading="loading">
            <div class="row justify-content-between">
                <div class="border border-1 border-primary rounded p-5 mb-15" v-for="(tableData, key) in tableDatas" :key="key">
                  <div class="d-flex justify-content-between">
                    <div>
                      <div class="fw-bold text-gray-900 fs-1"> {{ tableData.project.title }}</div>
                      <span class="fs-3 fw-semibold text-gray-500">{{ tableData.project.category.name }}</span>
                    </div>

                    <div class="d-flex flex-wrap justify-content-end w-50">
                      <Input
                          v-for="contact in tableData.project.contacts"
                          :key="contact.contact_id"
                          :name="'project'+contact.contact_id+'contact'"
                          container-class="form-group col-md-6 mb-2"
                          type="text"
                          inputClass="form-control form-control-lg form-control-solid"
                          size="sm"
                          :isDisabled="true"
                          :isRequired="false"
                          :is-input-group="true"
                          v-model="contact.contact_name"
                      >
                        <template #rightAddon>
                          <span class="position-absolute border-0 badge badge-primary end-0 top-50 translate-middle">
                            {{ contact.status_name }}
                          </span>
                        </template>
                      </Input>
                    </div>
                  </div>
                  <div class="p-8">
                    <template v-for="table in tableData.tables">
                      <project-formalities-details :table="table" />
                    </template>
                    <div v-if="tableData.tables.length === 0 && !loading" class="h-250px d-flex justify-content-center align-items-center text-center  " >
                      <div class="text-center ">
                        <div class="pt-8 ">
                          <Img filename="empty.png" alt=""
                               class="mw-100 h-125px h-sm-175px" />
                        </div>
                        <h4 class="fs-2x fw-bolder mb-0">{{ $t('projects.table.noData') }}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="tableDatas?.length === 0 && !loading" class="h-350px d-flex justify-content-center align-items-center text-center  " >
                  <div class="text-center ">
                    <div class="pt-8 ">
                      <Img filename="empty.png" alt=""
                           class="mw-100 h-125px h-sm-175px" />
                    </div>
                    <h4 class="fs-2x fw-bolder mb-0">{{ $t('reports.noData') }}</h4>
                  </div>
                </div>
            </div>
          </Loader>
        </template>
      </Card>
    </template>
  </SubLayout>
</template>

<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import Card from '@/components/Card.vue';
import Loader from '@/components/Loader.vue';
import SubLayout from '@/views/Layouts/partials/SubLayout.vue';
import { computed, onMounted, watch } from 'vue';
import { ref } from 'vue';
import { useStore } from 'vuex';
import Input from '@/components/Input.vue';
import ProjectFormalitiesDetails from "@/Modules/Projects/views/Reports/components/ProjectFormalitiesDetails.vue";
import Img from "@/components/Img.vue";

const store = useStore()

const loading = ref(false)
const isLoading = ref(false)

const tableDatas = ref([])

const query = ref({
  project_id: "",
  project_category_id: "",
  search: '',
  timeout: 0
})

const projects = ref([])


const categories = computed(() => store.getters['projectCategories/getProjectCategories'])

const fetchData = (query) => {
  loadData()
}

watch(() => query.value.search, (val) => {
  debouncedFetch(val)
})

watch(() => query.value.project_id, (val) => {
  loadData()
})

watch(() => query.value.project_category_id, (val) => {
  loadData()
})

const debouncedFetch = debounce(fetchData, 500)

const loadData = () => {
  loading.value = true
  store.dispatch('projects/loadProjectTables', query.value).then((response) => {
    tableDatas.value = response.data.data
  })
      .finally(() => {
        loading.value = false
      })
}

function debounce(fn, delay = 500) {
  return (...args) => {
    clearTimeout(query.value.timeout)
    query.value.timeout = setTimeout(() => fn(...args), delay)
  }
}


onMounted(() => {
  store.dispatch('projects/loadAllProjects').then((response) => projects.value = response.data.data)
  store.dispatch('projectCategories/loadProjectCategories')

  loadData()
})
</script>

